export var ValueMediaType;
(function (ValueMediaType) {
    ValueMediaType["Audio"] = "audio";
    ValueMediaType["Book"] = "book";
    ValueMediaType["Card"] = "card";
    ValueMediaType["Electronic"] = "electronic";
    ValueMediaType["Fiche"] = "fiche";
    ValueMediaType["Film"] = "film";
    ValueMediaType["Magazine"] = "magazine";
    ValueMediaType["Manuscript"] = "manuscript";
    ValueMediaType["Map"] = "map";
    ValueMediaType["Newspaper"] = "newspaper";
    ValueMediaType["Photo"] = "photo";
    ValueMediaType["Tombstone"] = "tombstone";
    ValueMediaType["Video"] = "video";
})(ValueMediaType || (ValueMediaType = {}));
//# sourceMappingURL=ValueMediaType.js.map